import styles from './AboutPage.module.css'

export default function AboutPage() {
  return (
    <div className={styles.page}>
      ABOUT
    </div>
  )
}